import React, { useEffect, useRef } from "react";
import pinkPNG from "../images/pink.png";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
//import Scrollbar from "smooth-scrollbar";

gsap.registerPlugin(ScrollTrigger);

export default function Pink() {
  const rectTransformsRef = useRef("");
  const circleTransformsRef = useRef("");

  function parallaxWobble(target, event, layer, ref, transformsRef) {
    let xTranslate;
    let yTranslate;
    try {
      if (transformsRef.current !== "") {
        let strTransf = transformsRef.current;
        if (strTransf.indexOf("%") > 0) {
          xTranslate =
            (parseInt(strTransf.substring(strTransf.indexOf("(") + 1, strTransf.lastIndexOf("%"))) *
              target.getBoundingClientRect().width) /
            100;
          yTranslate = 0;
        } else {
          xTranslate = parseInt(
            strTransf.substring(strTransf.indexOf("(") + 1, strTransf.lastIndexOf("px"))
          );
          yTranslate = parseInt(
            strTransf.substring(strTransf.indexOf("px, ") + 4, strTransf.lastIndexOf("px"))
          );
        }
      } else {
        xTranslate = 0;
        yTranslate = 0;
      }
    } catch {
      xTranslate = 0;
      yTranslate = 0;
    }

    let transAdj = layer * 60;
    let rotAdj = layer * 60;
    xTranslate = xTranslate - (event.pageX - ref.left - ref.width / 2) / transAdj;
    yTranslate = yTranslate - (event.pageY - ref.top - ref.height / 2) / transAdj;
    let xRotate = (event.pageY - ref.top - ref.height / 2) / rotAdj;
    let yRotate = -(event.pageX - ref.left - ref.width / 2) / rotAdj;

    target.style.transform =
      "translateX(" +
      xTranslate +
      "px) translateY(" +
      yTranslate +
      "px) translateZ(" +
      -200 * (1 / layer) +
      "px) rotateX(" +
      xRotate +
      "deg) rotateY(" +
      yRotate +
      "deg)  perspective(" +
      700 * layer +
      "px)";
  }

  useEffect(() => {
    let winWidth = window.innerWidth;
    let winHeight = window.innerHeight;

    let heroSection = document.querySelector(".hero-section");
    let heroSectionRect = heroSection.getBoundingClientRect();
    let pinkPNG = document.querySelector(".pink");
    let heroRect = document.querySelector(".hero-rect");
    let heroCircle = document.querySelector(".hero-circle");

    pinkPNG.style.transform =
      "translateX(0px) translateY(0px) translateZ(0px) rotateX(0deg) rotateY(0deg)  perspective(0px)";
    heroRect.style.transform =
      "translateX(0px) translateY(0px) translateZ(0px) rotateX(0deg) rotateY(0deg)  perspective(0px)";
    heroCircle.style.transform =
      "translateX(0px) translateY(0px) translateZ(0px) rotateX(0deg) rotateY(0deg)  perspective(0px)";

    // let stoppedScrolling = true;
    // let isScrolling;

    // function scrollListener() {
    //   stoppedScrolling = false;
    //   window.clearTimeout(isScrolling);
    //   isScrolling = setTimeout(function () {
    //     stoppedScrolling = true;
    //   }, 30);
    // }
    // try {
    //   let bodyScrollBar = Scrollbar.get(document.body);
    //   try {
    //     bodyScrollBar.removeListener(scrollListener);
    //   } catch {}
    //   bodyScrollBar.addListener(scrollListener);
    // } catch {}

    var isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf("CriOS") == -1 &&
      navigator.userAgent.indexOf("FxiOS") == -1;

    const parallaxEvent = function (e) {
      // if (stoppedScrolling === true) {
      if (!isSafari) {
        parallaxWobble(pinkPNG, e, 0.6, heroSectionRect, null);
        parallaxWobble(heroRect, e, 0.8, heroSectionRect, rectTransformsRef);
        parallaxWobble(heroCircle, e, 1, heroSectionRect, circleTransformsRef);
      }
      // }
    };

    heroSection.addEventListener("mousemove", parallaxEvent);

    function pinkStartTrigger() {
      if (winWidth <= 1024 && winHeight <= 1024) {
        return ".hero-rect";
      } else {
        return "#root";
      }
    }

    function pinkAnimStart(winWidth, offset) {
      if (winWidth <= 1024 && winHeight <= 1024) {
        return `bottom bottom`;
      } else {
        return `top top`;
      }
    }

    function pinkAnimEnd(winWidth, offset) {
      if (winWidth <= 1024 && winHeight <= 1024) {
        return `bottom center`;
      } else {
        return `bottom+=200 center`;
      }
    }

    //GSAP
    const rectSlide = gsap.fromTo(
      heroRect,
      {
        xPercent: 0,
      },
      {
        xPercent: () => `${25 - 5 * ((winWidth - 1500) / (350 - 1500))}`,
        scrollTrigger: {
          trigger: pinkStartTrigger(),
          start: pinkAnimStart(winWidth, 0),
          endTrigger: heroRect,
          end: pinkAnimEnd(winWidth, 0),
          scrub: true,
          onUpdate: setRectTransformsRef,
        },
      }
    );

    const circleRotate = gsap.fromTo(
      heroCircle,
      {
        y: 0,
        x: 0,
      },
      {
        y: -100,
        x: -100,
        scrollTrigger: {
          trigger: pinkStartTrigger(),
          start: pinkAnimStart(winWidth, 10),
          endTrigger: heroRect,
          end: pinkAnimEnd(winWidth, 0),
          scrub: true,
          onUpdate: setCircleTransformsRef,
        },
      }
    );

    function setRectTransformsRef() {
      rectTransformsRef.current = gsap.getProperty(heroRect, "transform");
    }

    function setCircleTransformsRef() {
      circleTransformsRef.current = gsap.getProperty(heroCircle, "transform");
    }

    return () => {
      heroSection.removeEventListener("mousemove", parallaxEvent);
      rectSlide.kill();
      circleRotate.kill();
    };
  }, []);

  return (
    <>
      <img className="pink" src={pinkPNG} alt="pink brain" />

      {/* <div className="hero-rect hero-rect-below"></div> */}
      <div className="hero-rect"></div>
      {/* <div className="hero-circle hero-circle-below"></div> */}
      <div className="hero-circle"></div>
    </>
  );
}
